export const createCourseInitialData = () => {

    const createHole = (index) => ({
        hole_index: index,
        latitude: null,
        longitude: null,
        coordinate: {
            type: "FeatureCollection",
            features: []
        }
    })


    const data = {
        course_name: "",
        total_holes: 9,
        latitude: null,
        longitude: null,
    }

    data['hole_details'] = Array.from({length: data.total_holes}, (_, i) => i + 1).map(createHole)
    return data
}


export const mapCoursesData = (data) => {

    if (!data?.length) return []

    return data.map(({course_name, golfcourseholes, hole_details, latitude, longitude, ...rest}) => {

        const {total_holes} = golfcourseholes;

        return {
            course_name,
            hole_details,
            total_holes,
            latitude,
            longitude,
            ...rest
        }
    })
}


export const createCoursesPayload = (state) => {
    return {}
}
